import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.module.css'
import { ko } from "date-fns/locale/ko";
import { } from "../../util/date";

const DateRangePicker = ({requestData, setRequestData}) => {
  // const [startDate, setStartDate] = useState(requestData.STDATE);
  // const [endDate, setEndDate] = useState(requestData.ENDATE);
  
  const handleStartDateSelect = (date) => {
    setRequestData((prev) => ({
      ...prev,
      STDATE : date
    }))
  }

  const handleEndDateSelect = (date) => {
    setRequestData((prev) => ({
      ...prev,
      ENDATE : date
    }))
  }

  // useEffect(() => {
  //   setRequestData((prev) => ({
  //     ...prev,
  //     STDATE: 
  //     ENDATE: 
  //   }));
  // }, [startDate, endDate])
  return (
    <>
      <DatePicker
        className="min-h-6 max-w-24 text-xs border border-black bg-yellow-100"
        selected={requestData.STDATE}
        onChange={(date) => handleStartDateSelect(date)}
        selectsStart
        locale={ko}
        startDate={requestData.STDATE}
        dateFormat="yyyy/MM/dd"
      />
      <div className="mx-1">~</div>
        <DatePicker
        className="min-h-6 max-w-24 text-xs border border-black bg-yellow-100"
        selected={requestData.ENDATE}
        onChange={(date) => handleEndDateSelect(date)}
        locale={ko}
        selectsEnd
        startDate={requestData.STDATE}
        endDate={requestData.ENDATE}
        minDate={requestData.STDATE}
        dateFormat="yyyy/MM/dd"
      />
    </>
  )
}

export default DateRangePicker;